export const FE_SLICES_CDN = "https://slices.static.events.ringcentral.com";
